import { render, staticRenderFns } from "./RegisterLayout.vue?vue&type=template&id=11f44933&"
import script from "./RegisterLayout.vue?vue&type=script&lang=js&"
export * from "./RegisterLayout.vue?vue&type=script&lang=js&"
import style0 from "./RegisterLayout.vue?vue&type=style&index=0&id=11f44933&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports